(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["racket-specs"] && !Shopify.designMode) return;
  try {
    
   var offsetTop = $('#r-skills-section').offset().top;
  $(window).scroll(function() {
   var height = $(window).height();
   if($(window).scrollTop()+height > offsetTop) {
     jQuery('.r-specs-bar').each(function(){
       jQuery(this).find('.r-specs-position').animate({
         left:jQuery(this).attr('data-percent') + '%'
       },2000);
     });
   }
   });

  } catch(e) { console.error(e); }
})();
})();
